import * as React from 'react';
import { compose, mapProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { Paper, Typography } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import './NewRecord.scss';
import WarningIcon from '@material-ui/icons/Warning';
import Button from 'components/common/Buttons/Button';
import Routes from '../../utils/routes/appRoutes';

export const TemplateNotFoundBase = props => {
  const { t: translate, history } = props;

  const handleReturnToHome = React.useCallback(() => {
    history.push(Routes.home.path);
  }, [history]);

  return (
    <div className="new-record-container">
      <div className="assessment-page assessment-row">
        <section className="col-sm-8 new-record-section">
          <Paper elevation={2} className="success-paper-style new-record-success-container">
            <div className="success-section">
              <WarningIcon className="warning-icon" />
              <Typography variant="h1" className="success-title">
                {translate('newRecord.somethingWentWrong')}
              </Typography>
              <Typography variant="h1">
                {translate('newRecord.templateDoesNotExist.copy1')}
                <br />
                {translate('newRecord.templateDoesNotExist.copy2')}
              </Typography>
              <Button variant="contained" className="create-another" onClick={handleReturnToHome}>
                {translate('common.returnHome')}
              </Button>
            </div>
          </Paper>
        </section>
      </div>
    </div>
  );
};

export const TemplateNotFoundHOC = compose(
  withTranslation(),
  withRouter,
  mapProps(props => ({
    t: props.t,
    history: props.history
  }))
);

export const TemplateNotFound = TemplateNotFoundHOC(TemplateNotFoundBase);
